module.exports = __webpack_public_path__ + "img/256-c18166.png";